import React, { useCallback, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { UserOutlined} from '@ant-design/icons';
import { Button, Form, Input, Alert, Row, Col, Select,Card, Tabs, Drawer,  Checkbox, Modal} from "antd";
import { addTemplatePageDraft,updateTemplatePageDraft,showLoading, hideLoading } from 'redux/actions/templatePage';
import { useHistory } from "react-router-dom";
import { motion } from "framer-motion"
import {  showAuthMessage, hideAuthMessage } from 'redux/actions/Auth';
import 'font-awesome/css/font-awesome.min.css';
import { useTranslation } from "react-i18next";
import {   EditorState,ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertToHTML } from 'draft-convert';
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
import html2canvas from "html2canvas";
import { EditorView } from "@codemirror/view";
import { WarningOutlined } from "@ant-design/icons";
import Loader from 'components/util-components/Loader';
import CustomBreadcrumb from 'components/util-components/CustomBreadcrumb';
import { AUTH_PREFIX_PATH } from 'configs/AppConfig';
import { BLOB_STORAGE_URL, PATH_VARIABLE } from 'constants/ApiConstant';
import PageHistory from 'components/util-components/PageHistory';
import ChatComponent from 'components/util-components/AIChatComponent';
import { debounce } from 'lodash';

export const AddTemplatePageDraft = (props) => {
	const { addTemplatePageDraft,updateTemplatePageDraft,showLoading,hideLoading, loading, redirect, message, showMessage, allowRedirect,status,cancel,templatePagesDraft,
		addEditPagesValue,selectedTab } = props
	const [form] = Form.useForm();
	const matchData = ["content","dataForPreview","pageName","description","comments","status"]
	let history = useHistory();
	const { t } = useTranslation();
	const { Option } = Select;
	const { TextArea } = Input;
	const {  param } = props;
	const { id } = param;
	const appId = id;
	const templateId = localStorage.getItem("templateId");
	const { TabPane } = Tabs;
	const [, setPreviewImage] = React.useState("console.log('hello world!');");
	const [code, setCode] = React.useState("");
	const [dataForPreview, setDataForPreview] = React.useState("{}");
	const [dataForPreviewMsz, setDataForPreviewMsz] = React.useState("");
	const [stable, setStable] = useState(false);
	var image="";
	const newWindowRef = useRef(null);
	const [selectedContentType,setSelectedContentType]=useState("html");
		// const openai = new OpenAI({
		// 	apiKey: "sk-svcacct-NSZ0s5JiafyDQPeG9Pdk_caZTgMNqPUjiBdMMbSMDYtMQvXT0b3lJMlflAP0DIGR-F1T3BlbkFJiODfF0-a78sBQxSq78A7YAwrsI8NILJ253YWn7BjFAML7cWgGp-oUbyoPrbOqeW0f-QA",
		// 	dangerouslyAllowBrowser: true 
		//   });

		const handleSelect = (value) => {
			setSelectedContentType(value);
		  };

	const customTheme = EditorView.theme({
		"&": {
		  direction: "ltr",
		  overflow: "hidden",
		  width: "100%",
		  height: "200px",
		  border: "none",
		},
		".cm-content": {
		  textAlign: "left",
		  padding: "0px",
		},
		".cm-scroller": {
		  overflow: "hidden",
		},
	  });

	  
	const [editorState, setEditorState] = useState(
		() => EditorState.createEmpty(),
	  );

	  const debouncedOnChange = useCallback(
		debounce((val) => {
		  console.log("Debounced value:", val);
		  openUpdateNewWindow(null,true);
		}, 2000),
		[]
	  );

      const onChange = React.useCallback((val, viewUpdate) => {
        console.log('val:', val);
        setCode(val);
		debouncedOnChange(val);
      }, [debouncedOnChange]);

	  const onChangeCheckBox = (e) => {
		setStable(e?.target?.checked);
	  };

	  const onChangeDataPreview = React.useCallback((val, viewUpdate) => {
        console.log('val:', val);
		try {
			const parsedJson = JSON.parse(val);
			val = JSON.stringify(parsedJson, null, 2); // Beautify JSON with 2 spaces
			setDataForPreview(val);
			setDataForPreviewMsz("");
		  } catch (error) {
			setDataForPreviewMsz(error.message); // Set the error message
			//parsedJson.value = null; // Clear parsed JSON
		  }
      }, []);

	const rules = {
		pageName: [
			{ 
				required: true,
				message:  t("impaqx.adminApp.blanPageName")
			},
			{	
				message: t("impaqx.adminApp.20CharName"),
				max : 40
			},
			// {
			// 	message:t("impaqx.adminApp.validateName"),
			// 	pattern: new RegExp(/^[a-zA-Z0-9_]+$/)
			// }
		],
		description: [
			{ 
				required: true,
				message: t("impaqx.adminApp.blankDescription")
			},
		],
		status: [
			{ 
				required: true,
				message: t("impaqx.adminApp.blankStatus")
			}
		]
	  
	}

    const backgroundStyle = {
        backgroundImage: 'url(/img/others/img-17.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    }

	const preview =()=>{
		const json = JSON.parse(dataForPreview);
		localStorage.setItem("code",code.replace(/\{\{(\w+)\}\}/g,
		(_, key) => json[key] || ""));
		// history.push(`/app/pages/edit-app/${appId}/templates/${templateId}/pages/preview`);
		if(selectedContentType=='vue'){
			window.open(`http://localhost:8082${PATH_VARIABLE}${AUTH_PREFIX_PATH}/templates/${templateId}/pages/${JSON.parse(templatePagesDraft)?.id}/preview-vue`, "_blank");
		}else{
		    window.open(`${PATH_VARIABLE}${AUTH_PREFIX_PATH}/templates/${templateId}/pages/preview`, "_blank");
		}
		// const newTab = window.open("", "_blank");
		// if (newTab) {
		// newTab.document.write(code.replace(/\{\{(\w+)\}\}/g,
		// (_, key) => json[key] || ""));
		// newTab.document.close();
		// } else {
		// alert("Popup blocked! Please allow popups for this site.");
		// }
	}

	const showPreviewModal =async () =>{
		await convertToImage(true);
	}

	const openUpdateNewWindow = (e,open) => {
		if (!open && (!newWindowRef.current || newWindowRef.current.closed)) {
		  // Open a new window
		  newWindowRef.current = window.open(
			"",
			"_blank",
			"width=600,height=400"
		  );
	
		  if (newWindowRef.current) {
			// Write initial HTML content
			newWindowRef.current.document.write(code);
		  }
		}else{
			if (newWindowRef.current && !newWindowRef.current.closed) {
		  newWindowRef.current.document.getElementById("root").innerHTML = code;
			}
		}
	  };

	const convertToImage= async (preview)=>{
		const json = JSON.parse(dataForPreview);

		const container = document.createElement("div");
		container.style.position = "absolute";
		container.style.left = "-9999px"; // Hide the container off-screen
		container.innerHTML = code.replace(/\{\{(\w+)\}\}/g,(_, key) => json[key] || "");
		document.body.appendChild(container);
		try {
		  // Use html2canvas to capture the rendered HTML
		  const canvas = await html2canvas(container);
		  const imageData = canvas.toDataURL("image/png"); // Generate Base64 image
		  console.log("Image Data URL:", imageData);
		  setPreviewImage(imageData);
		  image =imageData;
		  if(preview){
			localStorage.setItem("image",image);
			window.open(`${PATH_VARIABLE}${AUTH_PREFIX_PATH}/templates/${templateId}/pages/previewimage`, "_blank");
		}
		} catch (error) {
		  console.error("Error converting HTML to image:", error);
		} finally {
		  // Clean up the temporary container
		  document.body.removeChild(container);
		}
		}

		const publish = async () => {
			try {
				// Step 1: Convert to image
				await convertToImage();
				// Step 2: Validate the form
				const values = await form.validateFields();
				showLoading();
		
				// Step 3: Populate values
				const html = convertToHTML(editorState.getCurrentContent());
				values["description"] = html;
				values["appId"] = appId;
				values["stable"] = stable;
				values["templateId"] = templateId;
				values["content"] = code;
				values["dataForPreview"] = dataForPreview;
				values["previewImage"] = image; // Default to `image`
		        values["contentType"] = selectedContentType;
				const templatePagesDraftValue = JSON.parse(templatePagesDraft);
		
				// Step 4: Decide between update or create
				values["userEdited"] = localStorage.getItem("userId");
		
				if (templatePagesDraftValue?.id) {
					values["id"] = templatePagesDraftValue.id;
				await updateTemplatePageDraft({ values, publish: "publish" });
				} else {
					values["userCreated"] = localStorage.getItem("userId");
					values["status"] = "ACTIVE";
					await addTemplatePageDraft({ values, publish: "publish" });
				}
				// switchTabs("published");
				// cancel();
			} catch (error) {
				console.error("Error in publish:", error);
			}
		};
		

	const onAddTemplatePageDraft = async () => {
		try {
			await convertToImage();
	
			const values = await form.validateFields();
			showLoading();
			const html = convertToHTML(editorState.getCurrentContent());
			values["description"] = html;
			values["appId"] = appId;
			values["stable"] = stable;
			values["templateId"] = templateId;
			values["content"] = code;
			values["dataForPreview"] = dataForPreview;
			values["previewImage"] = image;
			values["contentType"] = selectedContentType;

			const templatePagesDraftValue = JSON.parse(templatePagesDraft);
	
			values["userEdited"] = localStorage.getItem("userId");
	
			if (templatePagesDraftValue?.id) {
				values["id"] = templatePagesDraftValue.id;
				const validate = validateReversion(templatePagesDraftValue, values);
              if (validate){
				await updateTemplatePageDraft({ values, undefined });
				// switchTabs("drafts");
		    }else{
				hideLoading();
			}
			} else {
				values["userCreated"] = localStorage.getItem("userId");
				values["status"] = "ACTIVE";
				await addTemplatePageDraft({ values, undefined });
				// switchTabs("drafts");
			}
			// cancel();
		} catch (error) {
			console.error("Error in onAddTemplatePageDraft:", error);
		}
	};
	
	const validateReversion = (original, changed) => {
		var changeFlag = false;
		matchData.forEach(element => {
				if (original[element] !== changed[element]) {
				  changeFlag = true;
				}
		}); 
		if (!changeFlag)
		  Modal.error({
			title: t("impaqx.adminApp.noDataChangeMessage"),
			icon: <WarningOutlined />,
			okText: t("impaqx.adminApp.close"),
			onOk() {},
		  });
		return changeFlag;
	  };

	useEffect(() => {
		if (allowRedirect) {
			history.push(redirect)
		}
		if(templatePagesDraft){
			const templatePagesDraftValue = JSON.parse(templatePagesDraft);
			setCode(templatePagesDraftValue?.content);
			setDataForPreview(templatePagesDraftValue?.dataForPreview);
			setPreviewImage(templatePagesDraftValue?.previewImage);
			setSelectedContentType(templatePagesDraftValue?.contentType?templatePagesDraftValue?.contentType:"html");
			if(templatePagesDraftValue.description)
			setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(templatePagesDraftValue.description))));
			form.setFieldsValue({
				code:templatePagesDraftValue?.content,
				dataForPreview:templatePagesDraftValue?.dataForPreview,
				previewImage:templatePagesDraftValue?.previewImage,
				pageName: templatePagesDraftValue.pageName,
				description: templatePagesDraftValue.description,
                comments: templatePagesDraftValue.comments,
				status: templatePagesDraftValue.status
			});
		}
  	}, [templatePagesDraft]);


	useEffect(() =>{
		// axios.post(`${API_ENDPOINT_BLOG_STORAGE_URL}/developerApp/blob-audit-data?entityName=templatePages&entityId=${}`, formData, {headers: {
		// 	'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		// 	'Content-Type': 'application/json',
		// 	accountUserId: localStorage.getItem("accountUserId"),
		// 	accountId: localStorage.getItem("accountId"),
		// 	appInstanceId: "developerPortal",
		// 	folder :`${appId}/templates/${localStorage.getItem("templateId")}`,
		// 	fileName : "style.css"
		// }}).then(res => {
		// 	hideLoading();
		// 	if(res.status===200) {
		// 		console.log(res.data);
		// 		setCode(res?.data);
		// 		form.setFieldsValue({
		// 			code:res?.data
		// 		})
		// 	}
		// }).catch(error=>{
		// 	hideLoading();
		//   console.log(error);
		// });
	},[])

	  const routes =templatePagesDraft?[
		{
		  path: "index",
		  breadcrumbName: t("impaqx.adminApp.pages")
		},
		{
		  path: "first",
		  breadcrumbName: t("impaqx.adminApp.editTemplatePageDraft")
		},
		{
			path: "second",
			breadcrumbName: JSON.parse(templatePagesDraft)?.pageName
		}
	  ]: [
		{
		  path: "index",
		  breadcrumbName: t("impaqx.adminApp.pages")
		},
		{
		  path: "first",
		  breadcrumbName: t("impaqx.adminApp.addNewTemplatePageDraft")
		},
	  ];

	return (
		<>
	  {loading? <Loader spinning={loading} cover="content"  />:null}
	  <Drawer
        contentWrapperStyle={{ maxWidth: '90%'}}
		bodyStyle={{padding:"10px 10px 10px 10px" }}
        width={1680}
				  placement="right"
				onClose={cancel}
				closable={false}
				visible={addEditPagesValue}
			>
				      <div  style={backgroundStyle}>
					  <div className="d-flex align-items-baseline ant-col ant-col-xs-24 ant-col-sm-24 ant-col-lg-24 ant-col-xl-5">
        <div className='productImg'>
           {localStorage.getItem("appLogoType")==="URL"?<img style={{width: '100%'}} src={`https://cdn.extremeb2b.com/cdn-cgi/image/width=75,quality=100/${localStorage.getItem("appLogo")}`} 
               onError={(e) => {
                e.target.src = `https://cdn.extremeb2b.com/cdn-cgi/image/width=75,quality=100/${BLOB_STORAGE_URL}/extremeb2b/appLogo/noimage.jpg`
                e.target.style = 'width: 100%'
             }}
             alt={localStorage.getItem("appLogo")}/>:null}
           {localStorage.getItem("appLogoType")==="IMAGE"? <img style={{width: '100%'}} src={`https://cdn.extremeb2b.com/cdn-cgi/image/width=50,quality=100/${BLOB_STORAGE_URL}/extremeb2b/appLogo/${localStorage.getItem("appLogo")}`} 
               onError={(e) => {
                e.target.src = `https://cdn.extremeb2b.com/cdn-cgi/image/width=75,quality=100/${BLOB_STORAGE_URL}/extremeb2b/appLogo/noimage.jpg`
                e.target.style = 'width: 100%'
             }} 
             alt={localStorage.getItem("appLogo")}/>:null}
           {localStorage.getItem("appLogoType")==="FONTAWESOME"? <span className={`${localStorage.getItem("appLogo")}`} style={{fontSize:'50px'}}></span>:null}
        </div>
        </div>
			{/* <div className="container d-flex flex-column justify-content-center h-100"> */}
                <Row justify="center">
        <Col xs={20} sm={20} md={20} lg={24}>
            <Card className="mt-4" align="left">
                <div className="my-2">
                    <div className="text-center">
                    {/* <img className="img-fluid mb-3" src={`${PATH_VARIABLE}/img/${theme === 'light' ? 'logo.png': 'logo-white.png'}`} alt="" width="200"/> */}
                    </div>
                    <Row justify="center">
                        <Col xs={24} sm={24} md={20} lg={24}>
			<motion.div 
				initial={{ opacity: 0, marginBottom: 0 }} 
				animate={{ 
					opacity: showMessage ? 1 : 0,
					marginBottom: showMessage ? 20 : 0 
				}}> 
				{message && message!=="" ?status===200?<Alert type="success" showIcon message={message}></Alert>:<Alert type="error" showIcon message={message}></Alert>:null}
			</motion.div>
			<Form form={form} layout="vertical" name="register-form" >
			<Row justify="space-between" align="middle" gutter={[16, 16]}>
  {/* Breadcrumb (Left Aligned) */}
  <Col>
    <CustomBreadcrumb routes={routes} />
  </Col>

  {/* Buttons (Right Aligned) */}
  <Col>
    <Row gutter={[12, 12]} wrap={false} align="middle">
      <Col>
        <Button type="primary" onClick={cancel}>
          {t("impaqx.adminApp.cancel")}
        </Button>
      </Col>
	  {/* <Col>
        <Button type="primary" onClick={openUpdateNewWindow} loading={loading}>
          {t("impaqx.adminApp.previewLive")}
        </Button>
      </Col> */}
      <Col>
        <Button type="primary" onClick={showPreviewModal} loading={loading}>
          {t("impaqx.adminApp.previewImage")}
        </Button>
      </Col>
      <Col>
        <Button type="primary" onClick={preview} loading={loading}>
          {t("impaqx.adminApp.preview")}
        </Button>
      </Col>
      <Col>
        <Button type="primary" onClick={onAddTemplatePageDraft} loading={loading}>
          {t("impaqx.adminApp.saveAsDraft")}
        </Button>
      </Col>
      <Col>
        <Button type="primary" onClick={publish} loading={loading}>
          {t("impaqx.adminApp.publish")}
        </Button>
      </Col>
    </Row>
  </Col>
</Row>

<Checkbox 
  style={{
    display: "flex",
    flexDirection: "row", // Aligns with the tabs
    justifyContent: "flex-end", // Moves it to the right end
    marginTop: "16px", // Adjust padding for a tab-like appearance
  }}
                            checked={stable}
                            onChange={onChangeCheckBox}
                          >
                            Stable
                          </Checkbox>
				{/* <Row justify="center" gutter={24}>
					<Col xs={24} sm={24} md={12} lg={12} className="gutter-row"> */}
					<Tabs defaultActiveKey="1">
						<TabPane tab="General" key="1">
						<Form.Item 
							name="pageName" 
							label={t("impaqx.adminApp.pageName")}
							rules={rules.pageName}
							hasFeedback={false}
						>
							<Input prefix={<UserOutlined className="text-primary" />}/>
						</Form.Item>
					{/* </Col>
					<Col xs={24} sm={24} md={12} lg={12} className="gutter-row"> */}
						{/* <Form.Item 
							name="displayLabel" 
							label={t("impaqx.adminApp.displayLabel")} 
							rules={rules.displayLabel}
							hasFeedback={false}
						>
							<Input prefix={<UserOutlined className="text-primary" />}/>
						</Form.Item> */}
					{/* </Col>
				</Row> */}
				{/*<Row justify="center" gutter={24}>
				 <Col xs={24} sm={24} md={12} lg={12} className="gutter-row"> */}
						<Form.Item 
							name="description" 
							label={t("impaqx.adminApp.description")} 
							// rules={rules.description}
							hasFeedback={false}
						>
							 <Editor
								editorState={editorState}
								onEditorStateChange={setEditorState}
								wrapperClassName="wrapper-class"
								editorClassName="editor-class"
								toolbarClassName="toolbar-class"
							/>
						   {/* <textarea style={{minWidth:'100%',borderRadius:'10px'}}  prefix={<UserOutlined className="text-primary" />} /> */}
							{/* <Input prefix={<UserOutlined className="text-primary" />}/> */}
						</Form.Item>
                        <Form.Item 
							name="comments" 
							label={t("impaqx.adminApp.comments")} 
							// rules={rules.comments}
							hasFeedback={false}
						>
							<TextArea />
                        </Form.Item>
					{/* </Col> */}
					{/* <Col xs={24} sm={24} md={12} lg={12} className="gutter-row">*/}
					{templatePagesDraft?<Form.Item 
							name="status" 
							label={t("impaqx.adminApp.status")} 
							rules={rules.status}
							hasFeedback={false}
						>
						  <Select>
							<Option value="ACTIVE">{t("impaqx.adminApp.active")}</Option>
							<Option value="INACTIVE">{t("impaqx.adminApp.inActive")}</Option>
					     </Select>
						</Form.Item>:null}
				{/*	</Col> 
				</Row>*/}
				</TabPane>
						<TabPane tab="Data For Preview" key="2">
						{dataForPreviewMsz && dataForPreviewMsz!=="" ?<Alert type="error" showIcon message={dataForPreviewMsz}></Alert>:null}
                <Form.Item 
							name="dataForPreview" 
							label={t("impaqx.adminApp.dataForPreview")} 
							rules={rules.dataForPreview}
							hasFeedback={false}
						>
              <CodeMirror
      value={dataForPreview}
	  height="auto"
	  minHeight='200px'
      extensions={[
        javascript({ jsx: true }),
        customTheme,
        EditorView.lineWrapping, // Enable line wrapping
      ]}
      onChange={onChangeDataPreview}
    />
			 </Form.Item>
			 </TabPane>
						<TabPane tab={t("impaqx.adminApp.content")} key="3">
						<Form.Item 
							name="contentType" 
							label={t("impaqx.adminApp.contentType")} 
							rules={rules.contentType}
							hasFeedback={false}
							placeholder={`${t("impaqx.adminApp.select")}`}
						>
						  <Select onSelect={handleSelect} defaultValue={selectedContentType}>
							<Option value="html">{t("impaqx.adminApp.html")}</Option>
							<Option value="vue">{t("impaqx.adminApp.vueJs")}</Option>
							<Option value="react">{t("impaqx.adminApp.reactJs")}</Option>
					     </Select>
						</Form.Item>
             <Form.Item 
							name="code" 
							// label={t("impaqx.adminApp.content")} 
							// rules={rules.content}
							hasFeedback={false}
						>
                <Row justify="space-around" gutter={[16, 16]}>
  <Col xs={24} sm={24} md={20} lg={11}>
    <Card className="mt-4" align="left">

      <Row justify="space-between" align="middle" gutter={[8, 8]} className="my-2">
        <Col>
          <h4>{t("impaqx.adminApp.content")}</h4>
        </Col>
      </Row>

      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
		  <CodeMirror
      value={code}
      height="auto"
	  minHeight='200px'
      extensions={[
        javascript({ jsx: true }),
        customTheme,
        EditorView.lineWrapping, // Enable line wrapping
      ]}
      onChange={onChange}
    />
        </Col>
      </Row>
    </Card>
  </Col>
  <Col xs={24} sm={24} md={20} lg={12}>

  {/* {messages.map((msg, index) => (
	<div
  key={index}
  className={`flex my-2 ${msg.role === "user" ? "justify-end ml-auto w-75" : "justify-start"}`}
>
  <div
   style={{
	backgroundColor: msg.role === "user" ? '#dddddd8c' : '#d0d0d029', // Light grey for user, medium grey for others
	border: msg.role === "user" ? '2px solid blue' : '2px solid red', // Custom border colors
  }}
    className={`${
      msg.role === "user" ?"max-w-xs" : "max-w-md"
    } p-4 rounded border overflow-auto whitespace-pre-wrap break-words border-gray-400 ${
      msg.role === "user" ? "text-right" : "text-left"
    }`}
  >
	              <div style={{ textAlign: "end",marginBottom:"15px" }}>
		{msg.role !== "user"?<a
              onClick={() => handleCopy(msg.content, index)}
            >
            <CopyTwoTone/>  {copiedIndex === index ? "Copied!" : "Copy"}
            </a>:null}
			</div>
        <pre>{msg?.content?.replace(/^```[a-z]*\n|```$/g, "")}</pre>
      </div>
    </div>
  ))} */}
  <ChatComponent  />

  </Col>
</Row> 
			 </Form.Item>
			 </TabPane>
			{templatePagesDraft? <TabPane tab={t("History")} key="4">
			  <PageHistory selectedTab={selectedTab} id={JSON.parse(templatePagesDraft)?.id} entityName={selectedTab=='drafts'?'templatePagesDrafts':'templatePages'} 
			  hideLoading={hideLoading} showLoading={showLoading} loading={loading} appInstanceId= "developerPortal"/>
				{/* <div className="p-4">
				  <DiffViewer oldVersion={oldVersion} newVersion={newVersion} />
				</div> */}
             </TabPane>:null}
			 {/* <TabPane tab={t("chat")} key="5">
				<ChatAI ></ChatAI>
			 </TabPane> */}
			 </Tabs>
			</Form>
            </Col>
								</Row>
							</div>
						</Card>
					</Col>
				</Row>
            {/* </div> */}
            </div>
			</Drawer>
		</>
	)
}

const mapStateToProps = ({templatePage}) => {
	const { loading, message, showMessage, token, redirect,allowRedirect,status,addEditPagesValue,selectedTab } = templatePage;
  return { loading, message, showMessage, token, redirect,allowRedirect,status,addEditPagesValue,selectedTab }
}

const mapDispatchToProps = {
    addTemplatePageDraft,
	updateTemplatePageDraft,
    showAuthMessage,
	hideAuthMessage,
	showLoading,
	hideLoading
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTemplatePageDraft)
